import { createFileRoute, redirect } from '@tanstack/react-router';
import type { SessionUserRoles } from '@rhino-project/core';
import { getLastMode, getLastOrgId } from '../../utils/prefStorage';

export type RootRedirectContext = {
  usersRoles?: SessionUserRoles[];
  baseOwner?: { id?: string | number } | null;
};

export type RootRedirectTarget =
  | { to: '/$owner' | '/$owner/plan'; params: { owner: string } }
  | { to: '/no-organization' };

export const buildRootRedirect = (
  rhino: RootRedirectContext
): RootRedirectTarget => {
  const storedOrgId = getLastOrgId();
  const storedIsValid =
    storedOrgId &&
    rhino.usersRoles?.some(
      (ur: SessionUserRoles) => String(ur.organization.id) === storedOrgId
    );

  // The base owner is picked from the roles, so its absence means there are no
  // organizations to land in rather than a role still being resolved
  const owner = rhino.baseOwner?.id ?? rhino.usersRoles?.[0]?.organization.id;
  if (owner === undefined) return { to: '/no-organization' };

  const targetOwner = storedIsValid ? storedOrgId : String(owner);

  if (getLastMode() === 'plan') {
    return { to: '/$owner/plan', params: { owner: targetOwner } };
  }

  return { to: '/$owner', params: { owner: targetOwner } };
};

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: ({ context: { rhino } }) => {
    throw redirect(buildRootRedirect(rhino));
  }
});
